import { Box as Flex, Typography as Text } from '@material-ui/core';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { PreviewShell } from './components';

interface DefaultResourcePreviewProps {
  artifact: AttachmentFragment;
  label: string;
}

export const DefaultResourcePreview = ({
  artifact,
  label,
}: DefaultResourcePreviewProps) => (
  <PreviewShell>
    <Flex
      display="flex"
      flexDirection="column"
      style={{
        gap: 'var(--encore-spacing-tighter-4)',
      }}
    >
      <Text
        variant="body1"
        style={{
          fontWeight: 'bold',
        }}
      >
        {artifact.displayName || extractLastNameComponent(artifact.uri)}
      </Text>
      <Text variant="body2" color="textSecondary">
        {label}
      </Text>
    </Flex>
  </PreviewShell>
);
